'use client';
import { XCircle, CheckCircle2, Zap, Users, Bot, Smartphone, LayoutTemplate } from 'lucide-react';
import styles from './Comparison.module.css';
import { ScrollAnimator } from '@/components/ScrollAnimator';

export function Comparison() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        
        <ScrollAnimator>
          <div className={styles.header}>
            <h2>Evolução da Gestão</h2>
            <p>Por que o mercado está migrando para o Aesir?</p>
          </div>
        </ScrollAnimator>

        <div className={styles.grid}>
          
          {/* O DISTINTIVO CENTRAL */}
          <div className={styles.vsBadge}>VS</div>

          {/* COLUNA ESQUERDA: O PROBLEMA */}
          <ScrollAnimator delay={100}>
            <div className={styles.cardOld}>
              <h3>ERP Tradicional</h3>
              <span className={styles.oldSubtitle}>Preso no passado</span>
              
              <ul className={styles.listOld}>
                <li className={styles.itemOld}>
                  <XCircle size={24} color="#ef4444" style={{flexShrink: 0}} />
                  <span><strong>Venda Casada:</strong> Você paga caro por módulos que sua empresa nunca vai usar.</span>
                </li>
                <li className={styles.itemOld}>
                  <XCircle size={24} color="#ef4444" style={{flexShrink: 0}} />
                  <span><strong>Interface Complexa:</strong> Telas cinzas, menus confusos e curva de aprendizado demorada.</span>
                </li>
                <li className={styles.itemOld}>
                  <XCircle size={24} color="#ef4444" style={{flexShrink: 0}} />
                  <span><strong>Atendimento Isolado:</strong> Um celular por vendedor, sem histórico e sem controle de metas.</span>
                </li>
                <li className={styles.itemOld}>
                  <XCircle size={24} color="#ef4444" style={{flexShrink: 0}} />
                  <span><strong>Preso no PC:</strong> Precisa baixar instalador (.exe) e não funciona direito no celular.</span>
                </li>
              </ul>
            </div>
          </ScrollAnimator>

          {/* COLUNA DIREITA: A SOLUÇÃO */}
          <ScrollAnimator delay={300}>
            <div className={styles.cardNew}>
              <div className={styles.popularBadge}>A Escolha Inteligente</div>
              <h3>Aesir ERP</h3>
              <span className={styles.newSubtitle}>O Futuro Unificado</span>
              
              <ul className={styles.listNew}>
                <li className={styles.itemNew}>
                  <CheckCircle2 size={24} color="#10b981" style={{flexShrink: 0}} />
                  <span><strong>100% Modular:</strong> Monte seu plano sob medida. Só pague pelo que realmente usar.</span>
                </li>
                <li className={styles.itemNew}>
                  <LayoutTemplate size={24} color="#3b82f6" style={{flexShrink: 0}} />
                  <span><strong>Material You 3:</strong> Design limpo padrão Google. Tão fácil de usar quanto um app de rede social.</span>
                </li>
                <li className={styles.itemNew}>
                  <Users size={24} color="#ea580c" style={{flexShrink: 0}} />
                  <span><strong>Marketing Massivo:</strong> Controle grupos e agende disparos de WhatsApp sem bloqueios.</span>
                </li>
                <li className={styles.itemNew}>
                  <Bot size={24} color="#8b5cf6" style={{flexShrink: 0}} />
                  <span><strong>IA & Omnichannel:</strong> Agentes virtuais qualificando clientes do Insta, Face e Whats 24/7.</span>
                </li>
                <li className={styles.itemNew}>
                  <Smartphone size={24} color="#14b8a6" style={{flexShrink: 0}} />
                  <span><strong>Nuvem & Mobile:</strong> Acesse seu estoque, caixa e métricas de qualquer lugar do mundo.</span>
                </li>
              </ul>
            </div>
          </ScrollAnimator>

        </div>
      </div>
    </section>
  );
}